import { forDesktop } from '@westwing/ui-kit/breakPoints';
import styled from 'styled-components';

const DynamicTitle = styled.div`
    font-family: ${({ theme }) => theme.fonts.fontChronicleRoman};
    line-height: 19px;
    color: ${({ theme }) => theme.colors.charcoal100};
    ${forDesktop`
        display: none;
    `}
`;

export default DynamicTitle;
